// BR 巴西逻辑

import vueI18n from '@/i18n/locale'
import caculateWidthBy10FontSize from '../caculateFontSize.js'
import { getMaxValue, getMaxLengthValue, isSmallScreenMobile } from '../utils.js'
import {
  LegendBuilder,
  XAxisBuilder,
  YAxisBuilder,
  WeekendBuilder,
  ToolTipBuilder,
  getEchartHeightAndBottomByLocale,
} from '../builderBR.js'
const { height, bottom, heightHor, bottomHor } = getEchartHeightAndBottomByLocale('completeOrder')

export default function transformer(data = {}, dateToWeek = {}, key = 'completeOrder', direction) {
  const { name, period, indicators } = data
  const horChartHeight = isSmallScreenMobile() ? heightHor - 24 : heightHor
  const chartHeight = direction === 'vertical' ? height : horChartHeight
  return {
    title: name,
    period,
    indicators,
    chartData: [
      parseChartsData(data.chartData, dateToWeek, key, direction, chartHeight),
      parseChartsDataSales(data.chartData, dateToWeek, key, direction, chartHeight), // parseAOPChartsData(data.chartData, dateToWeek, direction, chartHeight),
    ],
    chartHeight,
    chartkey: key,
  }
}

function parseChartsData(chartData = {}, dateToWeek, key, direction, chartHeight) {
  const {
    completeOrderCntNewCustomer = [], // 新客订单
    completeOrderCntOldCustomer = [], // 老客订单
    completeOrderNum = [], // 日完单量
  } = chartData || {}
  const max = getMaxValue({ completeOrderCntNewCustomer })
  const masAop = getMaxLengthValue({ completeOrderCntNewCustomer })
  const left = (max ? caculateWidthBy10FontSize(max) + 8 : 16) + 8
  const right = masAop ? caculateWidthBy10FontSize(masAop) : 8
  const xAxisData = completeOrderCntNewCustomer.map(item => item.date)

  return {
    grid: {
      top: 26,
      left,
      right,
      bottom: direction === 'vertical' ? bottom : bottomHor,
    },
    tooltip: ToolTipBuilder({
      position: { left: 0, bottom: chartHeight },
    }),
    legend: LegendBuilder([
      vueI18n.t('FoodB_Analysis_New_customers_vYDl' /** 新客 */),
      vueI18n.t('FoodB_Analysis_Old_people_fwCy' /** 老客 */),
      vueI18n.t('FoodB_APP_kvLF_MMXl' /** 日完单量 */),
    ]),
    xAxis: [
      XAxisBuilder({
        data: xAxisData.map(item => item.substring(5)),
      }),
    ],
    yAxis: [
      YAxisBuilder({
        name: vueI18n.t('Gattaran_opt_nyES_OcBw' /** Order */),
        nameTextStyle: {
          color: '#8D9099',
          fontSize: 10,
          align: 'left',
          padding: [0, 0, 0, -left + 8],
        },
      }),
    ],
    series: [
      {
        name: vueI18n.t('FoodB_Analysis_New_customers_vYDl' /** 新客 */),
        type: 'bar',
        barWidth: 4,
        color: '#FFC9AD',
        stack: 'test',
        data: completeOrderCntNewCustomer.map(item => item.value ?? '--'),
      },
      {
        name: vueI18n.t('FoodB_Analysis_Old_people_fwCy' /** 老客 */),
        type: 'bar',
        barWidth: 4,
        color: '#F76A31',
        stack: 'test',
        data: completeOrderCntOldCustomer.map(item => item.value ?? '--'),
      },
      {
        name: vueI18n.t('FoodB_APP_kvLF_MMXl' /** 日完单量 */),
        type: 'bar',
        barWidth: 4,
        color: '#ADDF6C',
        stack: 'test',
        data: completeOrderNum.map(item => item.value ?? '--'),
      },
      WeekendBuilder(xAxisData, dateToWeek),
    ],
  }
}

function parseChartsDataSales(chartData = {}, dateToWeek, key, direction, chartHeight) {
  const { customerPrice = [], totalSalesRevenue = [] } = chartData || []
  const max = getMaxValue({ customerPrice })
  const masAop = getMaxLengthValue({ customerPrice })
  const left = (max ? caculateWidthBy10FontSize(max) + 8 : 16) + 8
  const right = masAop ? caculateWidthBy10FontSize(masAop) : 8
  const xAxisData = customerPrice.map(item => item.date)

  return {
    grid: {
      top: 26,
      left,
      right,
      bottom: direction === 'vertical' ? bottom : bottomHor,
    },
    tooltip: ToolTipBuilder({
      position: { left: 0, bottom: chartHeight },
    }),
    legend: LegendBuilder([
      vueI18n.t('FoodD_2_Income_Vqfp' /** 收入 */),
      vueI18n.t('FoodB_Dimension_UVvy_UnnT' /** 客单价 */),
    ]),
    xAxis: [
      XAxisBuilder({
        data: xAxisData.map(item => item.substring(5)),
      }),
    ],
    yAxis: [
      YAxisBuilder({
        name: vueI18n.t('FoodD_2_Income_Vqfp' /** 收入 */),
        nameTextStyle: {
          color: '#8D9099',
          fontSize: 10,
          align: 'left',
        },
      }),
      YAxisBuilder({
        name: vueI18n.t('FoodB_Dimension_UVvy_UnnT' /** 客单价 */),
        nameTextStyle: {
          color: '#8D9099',
          fontSize: 10,
          align: 'right',
        },
      }),
    ],
    series: [
      {
        name: vueI18n.t('FoodD_2_Income_Vqfp' /** 收入 */),
        type: 'bar',
        barWidth: 4,
        color: '#FFC9AD',
        yAxisIndex: 0,
        stack: 'test',
        data: customerPrice.map(item => item.value ?? '--'),
      },
      {
        name: vueI18n.t('FoodB_Dimension_UVvy_UnnT' /** 客单价 */),
        type: 'line',
        barWidth: 4,
        color: '#ADDF6C',
        yAxisIndex: 1,
        stack: 'test',
        data: totalSalesRevenue.map(item => item.value ?? '--'),
      },
      WeekendBuilder(xAxisData, dateToWeek),
    ],
  }
}

// function parseAOPChartsData(chartData = {}, dateToWeek, key, direction, chartHeight) {
//   const { aop = [], asp = [] } = chartData || {}
//   const max = getMaxValue(chartData, ['aop', 'asp'])
//   const masAop = getMaxLengthValue({ aop: aop.concat(asp) })
//   const left = (max ? caculateWidthBy10FontSize(max) + 8 : 16) + 12
//   const right = masAop ? caculateWidthBy10FontSize(masAop) : 8
//   const xAxisData = aop.map(item => item.date)

//   return {
//     grid: {
//       top: 26,
//       left,
//       right,
//       bottom: direction === 'vertical' ? bottom : bottomHor,
//     },
//     tooltip: ToolTipBuilder({
//       position: { left: 0, bottom: chartHeight },
//     }),
//     legend: LegendBuilder([
//       {
//         name: vueI18n.t('FoodB_2_AOP_VVZV' /** AOP */),
//         icon: 'path://M960 470.857143H64c-5.028571 0-9.142857 4.114286-9.142857 9.142857v64c0 5.028571 4.114286 9.142857 9.142857 9.142857h896c5.028571 0 9.142857-4.114286 9.142857-9.142857v-64c0-5.028571-4.114286-9.142857-9.142857-9.142857z',
//       },
//       {
//         name: vueI18n.t('FoodB_APP_QiyP_UysU' /** ASP */),
//         icon: 'path://M960 470.857143H64c-5.028571 0-9.142857 4.114286-9.142857 9.142857v64c0 5.028571 4.114286 9.142857 9.142857 9.142857h896c5.028571 0 9.142857-4.114286 9.142857-9.142857v-64c0-5.028571-4.114286-9.142857-9.142857-9.142857z',
//       },
//     ]),
//     xAxis: [
//       XAxisBuilder({
//         data: xAxisData.map(item => item.substring(5)),
//       }),
//     ],
//     yAxis: [
//       YAxisBuilder({
//         name: vueI18n.t('FoodB_APP_PJrW_uBye' /** AOP/ASP */),
//         nameTextStyle: {
//           color: '#8D9099',
//           fontSize: 10,
//           align: 'left',
//           padding: [0, 0, 0, -left + 8],
//         },
//       }),
//     ],
//     series: [
//       {
//         name: vueI18n.t('FoodB_2_AOP_VVZV' /** AOP */),
//         type: 'line',
//         showSymbol: false,
//         yAxisIndex: 0,
//         color: '#5BD4AB',
//         lineStyle: {
//           width: 1.5,
//         },
//         data: aop.map(item => item.value),
//       },
//       {
//         name: vueI18n.t('FoodB_APP_QiyP_UysU' /** ASP */),
//         type: 'line',
//         showSymbol: false,
//         yAxisIndex: 0,
//         color: '#FFC9AD',
//         lineStyle: {
//           width: 1.5,
//         },
//         data: asp.map(item => item.value),
//       },
//       WeekendBuilder(xAxisData, dateToWeek),
//     ],
//   }
// }
